
import computeCanvasScale from '../utils/computeCanvasScale';

export const SET_CANVAS_SIZE = 'SET_CANVAS_SIZE';

const setCanvasSize = (state, payload) => {
  const { canvasWidth, canvasHeight } = payload;

  // ResizeObserver can emit 0×0 before flex layout settles (especially after remount).
  // Never persist zero — Konva Stage would render a 0×0 canvas (white container only).
  if (!canvasWidth || !canvasHeight) {
    return state;
  }

  if (
    state.canvasWidth === canvasWidth &&
    state.canvasHeight === canvasHeight
  ) {
    return state;
  }

  const {
    initialCanvasWidth = canvasWidth,
    initialCanvasHeight = canvasHeight,
  } = state;

  const nextState = {
    ...state,
    initialCanvasWidth,
    initialCanvasHeight,
  };

  return {
    ...nextState,
    canvasWidth,
    canvasHeight,
    canvasScale: computeCanvasScale(
      nextState,
      canvasWidth,
      canvasHeight,
    ),
  };
};

export default setCanvasSize;
